<template>
  <div class="page-info">
    <page-infomation v-if="page" :page="page" />
    <page-positions v-if="page" :page="page" />
    <page-prices v-if="page" :page="page" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PageInfomation from './components/Infomation.vue'
import PagePositions from './components/Positions.vue'
import PagePrices from './components/Prices.vue'

const bannersJSON = require('../../../public/banners.json')

export default {
  name: 'PagesInfo',
  components: {
    PageInfomation,
    PagePositions,
    PagePrices
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['language']),
    page () {
      return bannersJSON.pages.find((p) => p.id === this.$route.params.id)
    }
  },
  watch: {
    language: 'loadData'
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.page-info {
  min-height: 200px;
  .title {
    background-color: #2b314a;
    padding: 15px;
    margin-bottom: 20px;
    h3 {
      margin: 0;
      color: white;
    }
  }
}
</style>

